import {NgbTimeAdapter, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import moment, {Moment} from 'moment-timezone';
import { Injectable } from "@angular/core";

@Injectable()
export class MomentNgbTimeAdapter implements NgbTimeAdapter<Moment> {

  constructor() {
  }

  fromModel(value: Moment): NgbTimeStruct {
    if (value === undefined) {
      return undefined;
    } else if (value === null) {
      return null;
    } else {
      // If an invalid entry is entered into a text box, that entry is still passed and needs to not cause an error
      // so that it gets to validation code correctly
      if (value.tz) {
        return {hour: value.hour(), minute: value.minute(), second: value.second()};
      } else {
        return <any>value;
      }
    }
  }

  toModel(time: NgbTimeStruct): Moment {
    if (time === undefined) {
      return undefined;
    } else if (time === null) {
      return null;
    } else {
      return moment.utc(time.hour.toString() + ':' + time.minute.toString() + ':' + time.second.toString(), 'H:m:s');
    }
  }
}
